<template>
  <Swipe class="home-banner" :autoplay="3000" indicator-color="white">
    <SwipeItem v-for="item in state.banner" :key="item.id">
      <router-link :to="`/article/${item.id}`">
        <img :src="item.img" :alt="item.title">
      </router-link>
    </SwipeItem>
  </Swipe>
</template>

<script>
import { reactive } from 'vue'
import { getSwiperData } from '@/api/article'
import { Swipe, SwipeItem } from 'vant'
import 'vant/es/swipe/style'
export default {
  name: 'mHomeBaner',
  components: { Swipe, SwipeItem },
  props: {},
  setup (props) {
    const state = reactive({
      banner: []
    })
    const getData = async () => {
      const { list } = await getSwiperData()
      state.banner = list
    }
    getData()

    return {
      state
    }
  }
}
</script>
